import React from 'react';
import { Chip } from '../../../../../components/Chip';
import { ApprovalFlowStep } from '../../../../../entities/applicant_tracking/ApprovalFlow';
import { VerticalDivider } from '../../../../../components/VerticalDivider';
import { Avatar } from '../../../../../components/Avatar';
import { TruncateText } from '../../../../../components/TruncateText';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface PropTypes {
  step: ApprovalFlowStep;
  totalSteps: number;
  index: number;
}

function stepText(order: number, totalSteps: number) {
  if (totalSteps === 1) return 'Must be approved by:';
  if (order === totalSteps) return 'Last Approval';

  switch (order) {
    case 1:
      return 'Must be approved first by:';
    case 2:
      return 'Second Approval';
    case 3:
      return 'Third Approval';
    case 4:
      return 'Fourth Approval';
    default:
      return '';
  }
}

export function Step(props: PropTypes) {
  const users = props.step.approvers
    .filter((a) => a.user)
    .map((approver) => approver.user);

  return (
    <div className='d-flex mb-2'>
      <div className='d-flex flex-column align-items-center'>
        <div className='mb-2'>
          <Chip size='lg' className='text-blue-gray-900 bg-gray fw-bold'>
            {props.step.order}
          </Chip>
        </div>
        {props.step.order !== props.totalSteps && (
          <VerticalDivider classNames='flex-grow-1' />
        )}
      </div>
      <div className='ms-5h'>
        <div className={classNames('fs-5 text-dark-200', styles['step-row'])}>
          {stepText(props.step.order, props.totalSteps)}
        </div>
        <div className='d-flex flex-nowrap my-3'>
          {users.map((user, index) => (
            <div key={index} className='d-flex align-items-center'>
              <Avatar
                name={user.photoUrl ?? user.name}
                size='lg'
                type={user.photoUrl ? 'photo' : 'initials'}
              />
              <div className='text-dark-500 fs-5 fw-semibold text-nowrap'>
                <TruncateText
                  ellipsize
                  tooltip
                  text={user.name}
                  maxChars={25}
                />
              </div>
              {users.length - 1 !== index && (
                <div className='fs-6 text-dark-200 mx-2h'>OR</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
